import { Icon } from '@/components/icons/svg-icons';
import { inputFieldStyles } from './input-field.style';
import { forwardRef, MouseEventHandler, useState } from 'react';

type InputFieldCodeProps = {
	className?: string;
	codeImgSrc?: string;
	onRest?: MouseEventHandler<HTMLSpanElement>;
} & React.ComponentPropsWithRef<'input'>

export const InputFieldCode = forwardRef<HTMLInputElement, InputFieldCodeProps>(({
	className,
	codeImgSrc, 
	onRest,
	...otherProps
}, ref) => {
	const [isSpin, setIsSpin] = useState(false);
	return (
		<div className={className}>
			<input
				className={inputFieldStyles.inputText}
				{...otherProps}
				ref={ref}
			/><img src={codeImgSrc} className={inputFieldStyles.code}></img>
			<span 
				className={inputFieldStyles.reset} 
				data-active={isSpin} 
				onClick={(e) => {
					if (!isSpin) {
						setIsSpin(true);
						setTimeout(() => setIsSpin(false), 800)
						onRest && onRest(e)
					}
				}}
			>
				<Icon name="reset" />
			</span>
		</div>
	);
});

InputFieldCode.displayName = 'InputFieldCode';


